import Tooltip from 'admin/components/atoms/Tooltip';
import TransferBadge from 'admin/components/shared/TransferBadge';
import { formatDate, formatNum } from 'admin/utils';
import React from 'react';
import styled from 'styled-components';
import Table from '../../../atoms/Table';

const Badge = styled(TransferBadge)`
  border-radius: 6px;
`;

const AmountList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style-type: none;

  li {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 4px 0;

    &:first-child {
      justify-content: center;
      border-top: none;
    }
  }
`;

const headers = [
  { key: 'type', label: '種別', size: 1, align: 'left' },
  { key: 'done_at', label: '日時', size: 2, align: 'left' },
  {
    key: 'operator',
    label: (
      <div>
        更新者
        <Tooltip id="operator" text="取引キャンセルなどを行った管理ユーザーです" place="top" />
      </div>
    ),
    size: 2,
    align: 'left',
  },
  { key: 'amount', label: '総額', size: 3.5, align: 'center' },
  {
    key: 'description',
    label: (
      <div>
        説明文
        <Tooltip
          id="description"
          text="取引時のQRコードに設定されたメモや、キャンセル時のキャンセル理由などが表示されます"
          place="top"
        />
      </div>
    ),
    size: 3.5,
    align: 'left',
  },
];

const HistoryTable = ({ transaction }) => {
  return (
    <Table styles={{ marginTop: '40px' }}>
      <Table.Header>
        <Table.Row noBorder styles={{ backgroundColor: '#eee' }}>
          {headers.map((c) => (
            <Table.Cell size={c.size} key={c.key} align={c.align} styles={{ fontWeight: 'bold' }}>
              {c.label}
            </Table.Cell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {transaction?.rows?.map((row) => (
          <Table.Row noBorder key={row?.id}>
            <Table.Cell wordBreak="keep-all">
              <Badge transfer={row} />
            </Table.Cell>
            <Table.Cell>{formatDate(row.done_at)}</Table.Cell>
            <Table.Cell>{row.operator}</Table.Cell>
            <Table.Cell>
              <AmountList>
                <li>¥{formatNum(row.money_amount + row.point_amount)}</li>
                <li>
                  <span>マネー</span>
                  <span>¥{formatNum(row.money_amount)}</span>
                </li>
                <li>
                  <span>ポイント</span>
                  <span>¥{formatNum(row.point_amount)}</span>
                </li>
              </AmountList>
            </Table.Cell>
            <Table.Cell wordBreak="break-word">{row.description}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default HistoryTable;
